/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ScoreFlexListAliases {
  ADD_SCORE_FLEX_CUSTOM_DYNAMIC_BUTTON = 'add-score-flex-custom-dynamic-button',
  CONTEXTUAL_BAR = 'contextual-bar',
  DECK_SCORE_FLEX = 'deck-score-flex',
  FETCH_SCORE_FLEX = 'fetch-score-flex',
  FILTERED_LIST_SCORE_FLEX = 'filtered-list-score-flex',
  GLOBAL_ACTIONS_0 = 'global-actions-0',
  LAYOUT_SCORE_FLEX_LIST = 'layout-score-flex-list',
  LEGENDS_SCORE_FLEX = 'legends-score-flex',
  PANEL_GLOBAL_ACTIONS = 'panel-global-actions',
  SCORES_AND_INDEXES_CARD_SCORE_FLEX = 'scores-and-indexes-card-score-flex',
}
export { ScoreFlexListAliases };
